import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getOrFail } from 'mythil/object';
import MainApp from './MainApp';
import ForgotPassword from '../Pages/AuthPage/ForgotPassword';
import ResetPassword from '../Pages/AuthPage/ResetPassword';
// import GridTest from "../../test/GridTest";
// import Test from "../../test/DomNodeTest";
// import ChildTest from "../../test/ChildTest";
// import TypographyTest from "~/test/TypographyTest";
import { ThemeProvider as NativeBaseProvider } from  "~/native-ui"
import '~/css/quill.css';
import './default.css';
import { GlobalErrorBoundary } from './GlobalErrorBoundary';
import { ThemeStateGetter } from '../../StateGetters/ThemeStateGetter';
import { changePage } from '~/actions/actions';

const pages = {
    app: (<MainApp />),
    // test: (<Test />),
    // testgrid: (<GridTest />),
    // testchild: (<ChildTest />),
    // testtypography: (<TypographyTest />)
};

export class App extends Component {
    static propTypes = {
        page: PropTypes.string.isRequired,
    };

    componentDidMount() {
        this.props.changePage();
    }

    render() {
        return (
            <GlobalErrorBoundary>
                <NativeBaseProvider themeColor={ this.props.themeColor }>
                { getOrFail(pages, this.props.page, `Failed to get page ${this.props.page}`, pages) }
                </NativeBaseProvider>
            </GlobalErrorBoundary>
        )
    }
};

const RXApp = connect((state) => ({
    page: state.page,
    themeColor: new ThemeStateGetter(state).getThemeColor(),
}), (dispatch) => ({
    changePage: () => dispatch((dispatch, getState) => {
        const page = getState().router.result.page;
        if (!page) return;

        dispatch(changePage(page));
    }),
}))(App);

export default RXApp;